import React from "react";
import ECLCheckBox from "../../../ECLInputs/ECLCheckBox/ECLCheckBox";
import ECLTableCell from "./ECLTableCell";

export default function LeftColumns({
   row,
   index,
   tableSettings,
   columnSettings,
   instanceId,
   style = null,
   selection = undefined,
}) {
   return (
      <div
         className={
            "sticky-row" +
            (index % 2 !== 0 ? " table-alt-row" : "") +
            (tableSettings.hoverIndicator ? " table-row-hover" : "")
         }
         style={
            style
               ? { ...style, display: "flex" }
               : {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: tableSettings.rowHeight + "px",
                 }
         }
         role="row"
      >
         {selection && tableSettings.stickySelections && (
            <div
               role="cell"
               className="ecl-table-cell"
               style={{
                  width: "45px",
                  minWidth: "45px",
               }}
            >
               <ECLCheckBox
                  defaultChecked={row.selected}
                  id={"table-select-" + instanceId + index}
                  onClick={(e) => {
                     tableSettings.selectAction(index, e.target.checked);
                  }}
               />
            </div>
         )}
         {tableSettings.leftStickyCols &&
            tableSettings.leftStickyCols.map((key, i) => {
               const columnIndex = columnSettings.findIndex(
                  (c) => c.id === key,
               );

               return (
                  <ECLTableCell
                     columnSettings={columnSettings}
                     tableIndex={index}
                     columnInfo={columnSettings[columnIndex]}
                     hide={
                        tableSettings.columnHide
                           ? tableSettings.columnHide.includes(key)
                           : false
                     }
                     content={row.row[columnIndex]}
                     key={key + index + i}
                  />
               );
            })}
      </div>
   );
}
